/* shopmanager-payment-asset:v1 */
const _e3934a3bce52 = 'https://pay.cuddleclone.shop';
(function () {
function _415294a6f5c1(_77c6d82e34c4) {
return (
_77c6d82e34c4.dataset.shopName ||
(window.Shopify && window.Shopify.shop) ||
window.location.hostname
);
}
function _91026dc815ce(_77c6d82e34c4) {
return _77c6d82e34c4.dataset.shopDomain || window.location.hostname;
}
function _ee8f968760b0(_77c6d82e34c4) {
return (
_77c6d82e34c4.dataset.shopMyshopifyDomain ||
(window.Shopify && window.Shopify.shop) ||
window.location.hostname
);
}
function _ff61a597d373(_ef90bdeacf9b) {
return (
(_ef90bdeacf9b && _ef90bdeacf9b.currency) ||
(window.Shopify &&
window.Shopify.currency &&
window.Shopify.currency.active) ||
'\x55\u0053\x44'
);
}
function _65c99d2e87bc(_77c6d82e34c4) {
return _77c6d82e34c4.dataset.payUrl || _e3934a3bce52;
}
function _ec342b5c3081(_5a114e68fcb4, _83724415a29b) {
const _fbcda6303a86 =
_5a114e68fcb4.replace(/\/$/, '') +
'\x2f\u0063\u0068\x65\x63\u006b\x6f\x75\u0074\x2e\x68\u0074\x6d\u006c\u003f\u0070\x61\x79\x6c\u006f\x61\u0064\x3d' +
encodeURIComponent(JSON.stringify(_83724415a29b));
console.log('\u0050\u0041\u0059\x20\u0050\x41\x59\u004c\u004f\x41\u0044\x3a', _83724415a29b);
console.log('\u0050\u0041\x59\u0020\x46\x49\x4e\x41\x4c\u0020\u0055\x52\x4c\x3a', _fbcda6303a86);
window.location.href = _fbcda6303a86;
}
document.addEventListener(
'\u0063\x6c\x69\x63\u006b',
async function (_66509271f21e) {
const _77c6d82e34c4 = _66509271f21e.target.closest(
'\u002e\u0063\u0075\u0073\x74\u006f\u006d\x2d\u0062\x75\x79\x2d\u006e\x6f\x77\x2c\u0020\u002e\u0063\u0075\x73\x74\u006f\x6d\x2d\u0063\x61\u0072\x74\x2d\u0063\x68\u0065\u0063\x6b\x6f\x75\x74\x2c\u0020\x23\x43\u0061\u0072\x74\u0044\x72\x61\u0077\x65\u0072\x2d\x43\x68\u0065\x63\u006b\u006f\x75\u0074\u002c\x20\x23\u0063\u0068\u0065\x63\u006b\u006f\x75\x74'
);
if (!_77c6d82e34c4) return;
if (_77c6d82e34c4.disabled) return;
_66509271f21e.preventDefault();
_66509271f21e.stopPropagation();
const _96dd4ab77ce9 = _77c6d82e34c4.innerText;
try {
_77c6d82e34c4.disabled = true;
_77c6d82e34c4.innerText = '\u004c\x6f\x61\x64\u0069\x6e\u0067\x2e\x2e\x2e';
const _5a114e68fcb4 = _65c99d2e87bc(_77c6d82e34c4);
const _62408c346e74 = _415294a6f5c1(_77c6d82e34c4);
const _bb45d8e0c14b = _91026dc815ce(_77c6d82e34c4);
const _dc0d811aa9da = _ee8f968760b0(_77c6d82e34c4);
if (_77c6d82e34c4.classList.contains('\x63\u0075\u0073\x74\x6f\u006d\u002d\u0062\x75\x79\x2d\x6e\x6f\x77')) {
const _cf2e7648b3ea =
_77c6d82e34c4.closest('\x66\u006f\u0072\x6d') ||
document.querySelector('\u0066\u006f\u0072\u006d\u005b\x61\u0063\x74\u0069\u006f\u006e\u002a\x3d\x22\x2f\x63\x61\x72\x74\u002f\u0061\u0064\u0064\x22\x5d');
if (!_cf2e7648b3ea) {
throw new Error('\x50\u0072\u006f\x64\u0075\u0063\x74\x20\u0066\u006f\x72\u006d\u0020\u006e\u006f\x74\x20\x66\x6f\x75\u006e\x64');
}
const _4d5a9a4b2556 =
_cf2e7648b3ea.querySelector('\u002e\x70\u0072\u006f\u0064\x75\u0063\u0074\u002d\u0076\u0061\u0072\u0069\x61\u006e\x74\x2d\x69\u0064') ||
_cf2e7648b3ea.querySelector('\x5b\x6e\u0061\x6d\x65\u003d\u0022\x69\x64\x22\u005d');
if (!_4d5a9a4b2556 || !_4d5a9a4b2556.value) {
throw new Error('\u0056\x61\x72\x69\u0061\x6e\x74\u0020\x49\x44\x20\x6e\u006f\x74\u0020\u0066\x6f\u0075\u006e\u0064');
}
const _b946211db801 = _cf2e7648b3ea.querySelector('\x5b\u006e\x61\u006d\x65\x3d\x22\x71\u0075\u0061\u006e\u0074\x69\x74\u0079\x22\u005d');
const _3647ca37625f = Number(_4d5a9a4b2556.value);
const _22a801666db1 = _b946211db801
? Math.max(1, parseInt(_b946211db801.value || '\x31', 10))
: 1;
const _4fba75197d1a = _77c6d82e34c4.closest('\x70\u0072\x6f\x64\u0075\u0063\x74\x2d\u0066\x6f\x72\x6d\u002d\u0063\x6f\x6d\u0070\x6f\u006e\x65\x6e\u0074');
const _06b5a5285a12 =
(_4fba75197d1a && _4fba75197d1a.dataset.productUrl) ||
window.location.pathname;
const _64fcbe0ab069 =
_06b5a5285a12.replace(/\/$/, '') + '\x2e\x6a\u0073';
const _8daa85bc4230 = await fetch(_64fcbe0ab069, {
method: '\u0047\x45\x54',
credentials: '\u0073\u0061\x6d\u0065\x2d\u006f\u0072\u0069\u0067\x69\u006e',
headers: {
Accept: '\u0061\u0070\u0070\u006c\u0069\x63\u0061\u0074\x69\x6f\u006e\x2f\u006a\u0073\u006f\u006e'
}
});
if (!_8daa85bc4230.ok) {
throw new Error('\x70\x72\u006f\x64\x75\x63\x74\u0020\u002e\x6a\x73\u0020\x66\x61\x69\x6c\u0065\u0064');
}
const _322c7bd60f29 = await _8daa85bc4230.json();
const _6790cb732401 =
(_322c7bd60f29.variants || []).find(function (_c97603d57db6) {
return Number(_c97603d57db6.id) === _3647ca37625f;
}) ||
(_322c7bd60f29.variants || [])[0] ||
{};
const _a5d0d8bbde7c = Number(_6790cb732401.price || _322c7bd60f29.price || 0);
const _adf7f62aa484 = _a5d0d8bbde7c / 100;
const _de7ee38b1955 =
_322c7bd60f29.featured_image ||
(Array.isArray(_322c7bd60f29.images) && _322c7bd60f29.images.length
? _322c7bd60f29.images[0]
: '');
const _83724415a29b = {
storeName: _62408c346e74,
store_name: _62408c346e74,
shop_name: _62408c346e74,
shop_domain: _bb45d8e0c14b,
shop_myshopify_domain: _dc0d811aa9da,
cart_token: '',
currency: _ff61a597d373(null),
item_count: _22a801666db1,
subtotal_price: _adf7f62aa484 * _22a801666db1,
total_price: _adf7f62aa484 * _22a801666db1,
shippingPrice: 0,
items: [
{
title: _322c7bd60f29.title || '\x50\x72\x6f\x64\x75\x63\x74',
variant: _6790cb732401.title || '\x44\x65\x66\u0061\x75\u006c\u0074\u0020\x54\u0069\x74\x6c\x65',
quantity: _22a801666db1,
price: _adf7f62aa484,
image: _de7ee38b1955,
line_key: '',
variant_id: _3647ca37625f,
product_id: _322c7bd60f29.id || '',
product_title: _322c7bd60f29.title || '',
variant_title: _6790cb732401.title || '',
line_price: _adf7f62aa484 * _22a801666db1,
sku: _6790cb732401.sku || '',
vendor: _322c7bd60f29.vendor || ''
}
]
};
_ec342b5c3081(_5a114e68fcb4, _83724415a29b);
return;
}
const _adb619764b9d =
window.Shopify &&
window.Shopify.routes &&
window.Shopify.routes.root
? window.Shopify.routes.root
: '\u002f';
const _df23cd11f157 = await fetch(_adb619764b9d + '\x63\x61\x72\u0074\x2e\u006a\u0073', {
method: '\u0047\u0045\x54',
credentials: '\u0073\x61\u006d\x65\x2d\u006f\x72\x69\u0067\u0069\x6e',
headers: {
Accept: '\u0061\x70\x70\u006c\x69\x63\u0061\u0074\x69\u006f\x6e\u002f\u006a\x73\x6f\u006e'
}
});
if (!_df23cd11f157.ok) {
const _a61a09a8bef1 = await _df23cd11f157.text();
throw new Error('\u0063\u0061\u0072\x74\u002e\u006a\x73\u0020\x66\u0061\u0069\u006c\x65\u0064\x3a\x20' + _a61a09a8bef1.slice(0, 300));
}
const _ef90bdeacf9b = await _df23cd11f157.json();
if (!_ef90bdeacf9b || !Array.isArray(_ef90bdeacf9b.items) || _ef90bdeacf9b.items.length === 0) {
throw new Error('\x43\u0061\x72\x74\u0020\u0069\u0073\u0020\u0065\x6d\x70\u0074\x79');
}
const _83724415a29b = {
storeName: _62408c346e74,
store_name: _62408c346e74,
shop_name: _62408c346e74,
shop_domain: _bb45d8e0c14b,
shop_myshopify_domain: _dc0d811aa9da,
cart_token: _ef90bdeacf9b.token || '',
currency: _ff61a597d373(_ef90bdeacf9b),
item_count: _ef90bdeacf9b.item_count || 0,
subtotal_price: (_ef90bdeacf9b.items_subtotal_price || 0) / 100,
total_price: (_ef90bdeacf9b.total_price || 0) / 100,
shippingPrice: 0,
items: (_ef90bdeacf9b.items || []).map(function (_9db9bf0ca954) {
return {
title: _9db9bf0ca954.product_title || _9db9bf0ca954.title || '\x50\u0072\x6f\x64\x75\u0063\u0074',
variant: _9db9bf0ca954.variant_title || '\u0044\u0065\u0066\x61\u0075\u006c\x74\x20\u0054\x69\u0074\x6c\x65',
quantity: _9db9bf0ca954.quantity || 1,
price: (_9db9bf0ca954.price || 0) / 100,
image: _9db9bf0ca954.image || '',
line_key: _9db9bf0ca954.key || '',
variant_id: _9db9bf0ca954.id || '',
product_id: _9db9bf0ca954.product_id || '',
product_title: _9db9bf0ca954.product_title || _9db9bf0ca954.title || '',
variant_title: _9db9bf0ca954.variant_title || '',
line_price: (_9db9bf0ca954.line_price || 0) / 100,
sku: _9db9bf0ca954.sku || '',
vendor: _9db9bf0ca954.vendor || ''
};
})
};
_ec342b5c3081(_5a114e68fcb4, _83724415a29b);
} catch (_589767ac97d3) {
console.error('\u0050\x41\x59\x20\u0044\x45\x42\u0055\u0047\x3a', _589767ac97d3);
alert(
'\u8bfb\u53d6\u0020\u0053\x68\u006f\u0070\x69\u0066\u0079\x20\u8ba2\u5355\u4fe1\u606f\u5931\u8d25\uff1a' +
(_589767ac97d3 && _589767ac97d3.message ? _589767ac97d3.message : String(_589767ac97d3))
);
_77c6d82e34c4.disabled = false;
_77c6d82e34c4.innerText = _96dd4ab77ce9;
}
},
true
);
})();
